module.exports = __webpack_public_path__ + "img/white-arrow.bef11689.svg";